module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00297.89ea4833.jpg";